"use strict";

var INITIAL = 'INITIAL';
var AUTORENEWAL = 'AUTORENEWAL';
var FULFILLMENT = 'FULFILLMENT';
module.exports = {
  INITIAL: INITIAL,
  AUTORENEWAL: AUTORENEWAL,
  FULFILLMENT: FULFILLMENT
};